// Canonical vocabulary for the roster page's URL/state surface.
// The string values are part of the URL contract (?filter=at_risk&sort=avg_desc&…),
// so changing them is a breaking change to bookmarks. See PRD-04 §FR-28.

import type { RosterFilter, RosterSort } from "@api/students"

export const ROSTER_FILTERS = [
  "all",
  "at_risk",
  "no_deliveries",
] as const satisfies readonly RosterFilter[]

export const ROSTER_SORTS = [
  "name",
  "name_desc",
  "avg_asc",
  "avg_desc",
  "delivery_asc",
  "delivery_desc",
] as const satisfies readonly RosterSort[]

export const PAGE_SIZES = [25, 50, 100] as const
export type RosterPageSize = (typeof PAGE_SIZES)[number]

export const DEFAULT_ROSTER_STATE = {
  q: "",
  filter: "all" as RosterFilter,
  sort: "name" as RosterSort,
  page: 1,
  pageSize: 50 as RosterPageSize,
  studentId: null as string | null,
}

export const PAGE_SIZE_STORAGE_KEY = "platonica_roster_page_size"

/** PRD-61 — the `?cut=` value for "Todo el curso". Cut numbers are written
 *  as plain integers (`?cut=2`). Mirrors the export endpoint's `cut=all`. */
export const RESULTS_ALL_CUTS = "all"
